export const instantAccessItems: string[] = [
  'Les 6 niveaux complets, au format PDF haute définition',
  'Vocabulaire technique et repères visuels à chaque niveau',
  'Une progression complète prête à suivre, du Niveau 1 au Niveau 6',
  '144 exercices classés par difficulté, avec progressions et corrections',
  'Des adaptations déjà prévues pour la grossesse, la rééducation et le troisième âge',
  'Un matériel prêt à imprimer, sans mise en page à refaire',
  "Un accès immédiat après l'achat, sans délai d'attente",
  'Les mises à jour futures de la collection, incluses sans coût supplémentaire',
]
